// extracted by mini-css-extract-plugin
export default {"parent":"zoomControls_parent__czkoz","zoomImg":"zoomControls_zoomImg__GTb5t"};